import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../../Components/skeleton/skeleton';
import UserGroupLoader from '../../Components/user-group/loader';
import '../list-page/loader.scss';

export default function OrderListLoader({ removeUserGroup }) {
  return (
    <div className="table-loader-container">
      <table className="table-loader">
        <thead>
          <tr>
            {!removeUserGroup && (
              <th>
                <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
              </th>
            )}
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(4)].map(() => (
            <>
              <tr>
                {!removeUserGroup && (
                  <td>
                    <UserGroupLoader />
                  </td>
                )}

                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
              </tr>
              <tr>
                {!removeUserGroup && (
                  <td>
                    <UserGroupLoader />
                  </td>
                )}
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="10.417vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="10.417vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="10.417vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="10.417vw" />
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}
OrderListLoader.propTypes = {
  removeUserGroup: PropTypes.bool,
};
OrderListLoader.defaultProps = {
  removeUserGroup: false,
};
